import register from './register';
import finance from './finance';
import otp from './otp';
import tms from './tms';
import biddingManagement from './biddingManagement';
import contract from './contract';
import driverDelegateLetter from './driverDelegateLetter';
import legalPerform from './legalPerform';
import home from './home';
import warehouseResourceManagement from './warehouseResourceManagement.js'

const config = {
    ...register,
    ...finance,
    ...otp,
    ...tms,
    ...biddingManagement,
    ...contract,
    ...driverDelegateLetter,
    ...legalPerform,
    ...home,
    ...warehouseResourceManagement,
};
export default config;
